import { BaseApiClient } from '@/services/baseApiClient';
import queryString from 'qs';
import { RequestError, ValidationFailedError, uploadFile } from '@/utils/request';
import { captureException } from '@sentry/react';
import type { Args, Results } from '.';

export class InvoiceRecordsApiClient extends BaseApiClient {
  constructor() {
    super('api/records/invoice');
  }

  public create(payload: Args.CreateInvoiceRecordArgs): Promise<Results.CreateInvoiceRecordResult> {
    return this.http.post('', payload);
  }

  public update({ id, payload }: Args.UpdateInvoiceRecordArgs): Promise<Results.UpdateInvoiceRecordResult> {
    return this.http.put(`${id}`, payload);
  }

  public delete(invoiceRecordId: Args.DeleteInvoiceRecordArgs): Promise<Results.DeleteInvoiceRecordsResult> {
    return this.http.delete(invoiceRecordId);
  }

  public deleteBulk(body: Args.DeleteInvoiceRecordsBulkArgs): Promise<Results.DeleteInvoiceRecordsBulkResult> {
    return this.http.delete('', body);
  }

  public async import({
    importFile,
    importType,
    attachments,
  }: Args.ImportInvoiceRecordArgs): Promise<Results.ImportInvoiceRecordsResult> {
    const formData = new FormData();
    formData.append('importFile', importFile);

    for (const attachment of attachments) {
      formData.append('attachment', attachment);
    }

    try {
      return await uploadFile(`api/records/import?${queryString.stringify({ importType })}`, formData, {
        signal: undefined,
      });
    } catch (e) {
      // invalid rows come back as 412 `{ errored }`, which the import panel shows in the result step
      if (e instanceof RequestError && !(e instanceof ValidationFailedError) && e.response.status === 412) {
        return await e.response.json<Results.ImportInvoiceRecordsResult>();
      }
      console.error(e);
      captureException(e);
      throw e;
    }
  }
}
